import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Laudo: React.FC = () => (
  <div style={{
    minHeight: '100vh',
    background: '#000000',
    color: '#222',
    fontFamily: "'Merriweather', 'Georgia', serif",
    display: 'flex',
    flexDirection: 'column'
  }}>
    <Header />
    <main style={{
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'flex-start'
    }}>
      <div style={{
        maxWidth: 900,
        width: '100%',
        margin: '48px auto',
        background: '#fff',
        padding: 40,
        borderRadius: 8,
        boxSizing: 'border-box',
        boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
      }}>
        <div style={{ borderBottom: '2px solid #0a3d62', marginBottom: 18, paddingBottom: 8 }}>
          <span style={{ fontWeight: 700, fontSize: 18, color: '#0a3d62', letterSpacing: 1 }}>Marcos Albuquerque</span>
          <span style={{ float: 'right', color: '#888', fontSize: 15 }}>BELÉM</span>
        </div>
        <h1 style={{
          color: '#0a3d62',
          fontWeight: 900,
          fontSize: 32,
          margin: '0 0 18px 0',
          fontFamily: "'Merriweather', 'Georgia', serif"
        }}>
          Laudo comprova contaminação no Aurá e recomenda interdição imediata
        </h1>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <img
            src="/images/logo/folhabelem.png"
            alt="Déchets toxiques à Belém"
            style={{
              width: '100%',
              maxWidth: 700,
              borderRadius: 8,
              margin: '20px 0'
            }}
          />
        </div>
        <p style={{ fontSize: 18, lineHeight: 1.7, marginBottom: 18 }}>
          Um laudo técnico divulgado pela ONG <b>Verde para o Futuro</b> comprova que o solo e a água no bairro Aurá estão contaminados por resíduos sólidos e tóxicos descartados de forma irregular. O documento aponta grave risco à saúde pública e recomenda a interdição imediata da área afetada.
        </p>
        <p style={{ fontSize: 17, lineHeight: 1.7 }}>
          O relatório detalha que análises laboratoriais detectaram <b>Salmonella enterica</b>, coliformes fecais e resíduos orgânicos acima dos limites permitidos por lei. Moradores relataram casos de <b>Febre Tifóide</b>, com risco elevado para crianças, idosos e pessoas imunocomprometidas.
        </p>
        
        <div style={{
          background: '#eaf6fb',
          borderLeft: '5px solid #0a3d62',
          padding: '18px 22px',
          margin: '28px 0',
          borderRadius: 6,
          fontSize: 16.5,
          color: '#0a3d62'
        }}>
          O laudo surge após manifestações em frente ao hotel Mercure, onde moradores exibiam cartazes com os dizeres <b>“Lixo mata!”</b> e <b>“Justiça para o Aurá”</b>. Relatos de adoecimento na comunidade reforçam a urgência do problema.
        </div>
        <p style={{ fontSize: 17, lineHeight: 1.7 }}>
          A investigação aponta que a prestadora <b>Lev Descartes</b>, responsável pelo descarte, está sob investigação por falsificação de laudos e lavagem de dinheiro. A rede hoteleira <b>Accor</b>, cliente da prestadora, também é alvo de inquérito civil do Ministério Público do Pará por crime ambiental, negligência sanitária e racismo ambiental.
        </p>
        <p style={{ fontSize: 17, lineHeight: 1.7 }}>
          O caso viralizou nas redes sociais, sendo compartilhado por influenciadores, ONGs e celebridades. Moradores e ativistas denunciam que bairros nobres não enfrentariam o mesmo descaso, caracterizando racismo ambiental.
        </p>
        <div style={{
          margin: '32px 0 18px 0',
          padding: '18px 22px',
          background: '#f9f9f9',
          borderRadius: 6,
          border: '1px solid #e0e0e0'
        }}>
          <span style={{ fontWeight: 700, color: '#0a3d62', fontSize: 17 }}>O laudo da ONG recomenda:</span>
          <ul style={{ margin: '14px 0 0 18px', fontSize: 16.5, lineHeight: 1.6 }}>
            <li>Interdição imediata da área;</li>
            <li>Suspensão das atividades de descarte até nova avaliação técnica;</li>
            <li>Limpeza emergencial e contenção da contaminação;</li>
            <li>Monitoramento contínuo de solo e água;</li>
            <li>Assistência médica emergencial aos moradores;</li>
            <li>Abertura de processos civis e criminais contra prestadoras e empresas envolvidas;</li>
            <li>Divulgação pública do laudo para garantir transparência e pressão social.</li>
          </ul>
        </div>

        {/* Seção do Laudo Técnico */}
        <div style={{
          margin: '48px 0 0 0',
          padding: '32px 24px',
          background: '#f4f4f4',
          borderRadius: 8,
          border: '1px solid #d0d0d0',
          fontFamily: "'Merriweather', 'Georgia', serif"
        }}>
          <h2 style={{ color: '#0a3d62', fontWeight: 800, fontSize: 24, marginBottom: 12, borderBottom: '1px solid #b0c4de', paddingBottom: 6 }}>
            ONG VERDE PARA O FUTURO<br />
            LAUDO TÉCNICO AMBIENTAL Nº 003/2025
          </h2>
          <div style={{ fontSize: 16.5, marginBottom: 10 }}>
            <b>Assunto:</b> Contaminação do solo e da água por descarte irregular de lixo – Bairro Aurá, Belém (PA)<br />
            <b>Data:</b> 02 de outubro de 2025<br />
            <b>Localidade:</b> Belém – PA
          </div>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginTop: 18 }}>1. IDENTIFICAÇÃO</h3>
          <ul style={{ marginLeft: 18, fontSize: 16 }}>
            <li>Elaborador: ONG Verde para o Futuro – CNPJ: 11.222.333/0001-44</li>
            <li>Responsável técnico: Dra. Mariana Almeida – Bióloga (CRBio XXXX)</li>
            <li>Área de investigação: Bairro Aurá, próximo ao Mercure Belém e ao córrego local</li>
            <li>Motivação: Manifestações de moradores com cartazes denunciando mortes por causa do descarte irregular de lixo (“Lixo mata!” e “Justiça para o Aurá”), relatos de adoecimento da comunidade, e vídeos que registram descarte irregular em área de mata.</li>
          </ul>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginTop: 18 }}>2. OBJETIVO</h3>
          <p style={{ fontSize: 16 }}>
            Avaliar a qualidade do solo e da água em áreas do entorno do córrego do Aurá, identificar riscos à saúde pública e fornecer recomendações técnicas para interdição e contenção do local, em função de descartes irregulares de resíduos sólidos e tóxicos.
          </p>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginTop: 18 }}>3. METODOLOGIA</h3>
          <ul style={{ marginLeft: 18, fontSize: 16 }}>
            <li>Visitas e observação direta das áreas de descarte e arredores do hotel Mercure;</li>
            <li>Entrevistas com moradores e líderes comunitários, confirmando relatos de doenças e impacto ambiental;</li>
            <li>Coleta de amostras de solo e água em cinco pontos críticos próximos ao córrego e áreas de descarte;</li>
            <li>Análise laboratorial de metais pesados (chumbo, mercúrio, cádmio), coliformes fecais, resíduos orgânicos e químicos, seguindo protocolos da ABNT NBR 10.004 e Resolução CONAMA nº 357/2005;</li>
            <li>Levantamento de dados de saúde fornecidos pela Secretaria Municipal de Saúde: 52 casos de doenças respiratórias e dermatológicas confirmadas;</li>
            <li>Revisão de evidências públicas, incluindo vídeo de drone mostrando pilhas de lixo sendo despejadas irregularmente, com mais de 1 milhão de visualizações.</li>
          </ul>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginTop: 18 }}>4. RESULTADOS</h3>
          <b>4.1 Contaminação ambiental</b>
          <ul style={{ marginLeft: 18, fontSize: 16 }}>
            <li>Solo: concentração de metais pesados acima dos limites legais (chumbo: 3,2 mg/kg; mercúrio: 0,08 mg/kg); presença de resíduos plásticos, borracha e restos orgânicos; infiltração de chorume em subsolo.</li>
            <li>Água: coliformes fecais acima do permitido (10⁵ UFC/100ml); metais pesados presentes acima do limite legal; turbidez e odor perceptíveis. Presença de Salmonella enterica nas amostras coletadas.</li>
            <li>Evidências de descarte irregular por prestadora de serviços (Lev Descartes), atualmente investigada por falsificação de laudos e lavagem de dinheiro, conforme informação da Polícia Ambiental.</li>
          </ul>
          <b>4.2 Impacto à saúde pública</b>
          <ul style={{ marginLeft: 18, fontSize: 16 }}>
            <li>52 casos confirmados de doenças respiratórias e dermatológicas em moradores próximos ao córrego;</li>
            <li>Risco elevado para crianças, idosos e pessoas imunocomprometidas;</li>
            <li>Vídeo de drone e manifestações comunitárias indicam exposição contínua e recorrente a resíduos tóxicos.</li>
          </ul>
          <b>4.3 Contexto social e legal</b>
          <ul style={{ marginLeft: 18, fontSize: 16 }}>
            <li>A rede Accor e a prestadora Lev Descartes estão sob inquérito civil do Ministério Público do Pará por crime ambiental, negligência sanitária e racismo ambiental;</li>
            <li>Influenciadores e ONGs têm denunciado o caso publicamente, gerando repercussão internacional;</li>
            <li>Manifestantes associam a situação a racismo ambiental, argumentando que bairros nobres não enfrentariam este tipo de negligência.</li>
          </ul>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginTop: 18 }}>5. CONCLUSÃO</h3>
          <p style={{ fontSize: 16 }}>
            Os dados técnicos e epidemiológicos comprovam a contaminação do solo e da água no entorno do córrego do Aurá, diretamente relacionada ao descarte irregular de resíduos sólidos e tóxicos. A situação representa grave risco à saúde pública, caracterizando negligência ambiental e social por parte das empresas envolvidas.
          </p>
          <h3 style={{ fontWeight: 700, fontSize: 18, marginTop: 18 }}>6. RECOMENDAÇÕES</h3>
          <ol style={{ marginLeft: 18, fontSize: 16 }}>
            <li>Interdição imediata da área afetada, impedindo o acesso de moradores e circulação de veículos;</li>
            <li>Suspensão das atividades de descarte de resíduos por prestadoras na região até nova avaliação técnica;</li>
            <li>Limpeza emergencial e contenção da contaminação, incluindo remoção de resíduos e barreiras físicas;</li>
            <li>Monitoramento contínuo da água e do solo até normalização;</li>
            <li>Assistência médica emergencial aos moradores da região;</li>
            <li>Abertura de processos civis e criminais contra prestadoras e empresas envolvidas, incluindo investigação sobre descaso e racismo ambiental;</li>
            <li>Divulgação pública do laudo para garantir transparência e pressão social sobre a situação.</li>
          </ol>
          <div style={{ marginTop: 18, fontSize: 16 }}>
            Belém (PA), 02 de outubro de 2025<br />
            Dra. Mariana Almeida<br />
            Bióloga – CRBio 1111<br />
            ONG Verde para o Futuro
          </div>
          <div style={{ marginTop: 24 }}>
            <a
              href="/files/Laudotecnicoambiental.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#0a3d62',
                fontWeight: 700,
                textDecoration: 'underline',
                fontSize: 17
              }}
            >
              Baixar laudo técnico em PDF
            </a>
          </div>
        </div>
        <div style={{ color: '#888', fontSize: 15, marginTop: 32, borderTop: '1px solid #eee', paddingTop: 12 }}>
          A reportagem seguirá acompanhando o caso.
        </div>
      </div>
    </main>
    <Footer />
  </div>
);

export default Laudo; 